import i18next from "i18next";
import deTranslations from "../data/i18n/de.json";
import enTranslations from "../data/i18n/en.json";
import esTranslations from "../data/i18n/es.json";
import keysTranslations from "../data/i18n/keys.json";
const localI18n = i18next.createInstance();
export const i18nInit = async (language) => {
    await localI18n.init({
        fallbackLng: 'de',
        lng: language,
        resources: {
            de: { translation: deTranslations },
            en: { translation: enTranslations },
            es: { translation: esTranslations },
            keys: { translation: keysTranslations },
        },
    });
};
export default localI18n;
